import { RESET_STATE } from 'store/global/actions';

import { PRICING_STATUS_ACTION_TYPE } from '../actions';

const initialState = {
  applicationId: null,
  externalLoanId: null,
  floatDownConfiguration: {
    applicationId: null,
    isAllowed: false,
    reasons: [],
  },
  isLocked: false,
  isLockPending: false,
  isRelockRequired: false,
  isUpdateRequestPending: false,
  lockDeskConfiguration: {
    applicationId: null,
    isAllowed: false,
    isManualPriceCalculationAllowed: false,
    reasons: [],
  },
  priceConcessionConfiguration: {
    allowed: false,
    reasons: [],
  },
  pricingEngineType: null,
  programChangeConfiguration: {
    applicationId: null,
    allowed: true,
    reasons: [],
  },
  relockConfiguration: {
    applicationId: null,
    allowed: false,
    reasons: [],
  },
  updateRequests: [],
};

const pricingStatusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICING_STATUS_ACTION_TYPE.UPDATE_PRICING_STATUS:
      if (!payload) {
        return initialState;
      }

      return {
        ...payload,
        programChangeConfiguration:
          payload.programChangeConfiguration ?? initialState.programChangeConfiguration,
        relockConfiguration: payload.relockConfiguration ?? initialState.relockConfiguration,
        lockDeskConfiguration: payload.lockDeskConfiguration ?? initialState.lockDeskConfiguration,
        floatDownConfiguration:
          payload.floatDownConfiguration ?? initialState.floatDownConfiguration,
        priceConcessionConfiguration:
          payload.priceConcessionConfiguration ?? initialState.priceConcessionConfiguration,
      };

    case PRICING_STATUS_ACTION_TYPE.RESET_PRICING_STATUS:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default pricingStatusReducer;
